<template>
  <div
    v-if="links?.length"
    class="flex flex-col items-start border-t border-gray-400 py-4"
  >
    <CmsButton
      v-for="(link, i) in links"
      :key="`plp-recommendation-${i}`"
      type="link-alternative"
      :blok="link"
      >{{ link.cta_label }}
    </CmsButton>
  </div>
</template>

<script setup lang="ts">
import { CmsBaseFolder } from '~/constants/cms'

import type {
  RecommendationLinkFieldNames,
  SbLink,
  SbProductRecommendationLinks,
} from '~/storyblok/types/storyblok'

const props = defineProps({
  fieldName: {
    type: String as PropType<RecommendationLinkFieldNames>,
    required: true,
  },
})

const { data } = await useCmsStory<SbProductRecommendationLinks>({
  params: {
    baseFolder: CmsBaseFolder.Recommendations,
    slug: 'product-recommendation-links',
  },
})

const links = computed(
  () =>
    (data.value?.content?.[props.fieldName] ?? []).filter(
      (link) => link.cta_url,
    ) as SbLink[],
)
</script>
